export default {"src":"/_next/static/media/heroShape.440a6875.svg","height":418,"width":775,"blurWidth":0,"blurHeight":0};